// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AdminInviteRouteImport } from './routes/admin-invite'
import { Route as AffiliatePortalRouteImport } from './routes/affiliate-portal'
import { Route as AppRouteImport } from './routes/app'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as BusinessNetworkingDinnersRouteImport } from './routes/business-networking-dinners'
import { Route as ChoosePlanRouteImport } from './routes/choose-plan'
import { Route as CirclesRouteImport } from './routes/circles'
import { Route as CitiesRouteImport } from './routes/cities'
import { Route as ConciergeSubmittedRouteImport } from './routes/concierge-submitted'
import { Route as ConnectionsRouteImport } from './routes/connections'
import { Route as CouplesDinnerExperiencesRouteImport } from './routes/couples-dinner-experiences'
import { Route as CuratedDiningExperiencesRouteImport } from './routes/curated-dining-experiences'
import { Route as CuratedMatchmakingDinnersRouteImport } from './routes/curated-matchmaking-dinners'
import { Route as CuratorPortalRouteImport } from './routes/curator-portal'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DatingAppAlternativeRouteImport } from './routes/dating-app-alternative'
import { Route as DatingThroughDinnerRouteImport } from './routes/dating-through-dinner'
import { Route as DinnerClubRouteImport } from './routes/dinner-club'
import { Route as DinnerWithStrangersRouteImport } from './routes/dinner-with-strangers'
import { Route as DiscoverRouteImport } from './routes/discover'
import { Route as EmailStatusRouteImport } from './routes/email-status'
import { Route as EmailUnsubscribeRouteImport } from './routes/email-unsubscribe'
import { Route as EntrepreneurDinnersRouteImport } from './routes/entrepreneur-dinners'
import { Route as EventsRouteImport } from './routes/events'
import { Route as ExperiencesRouteImport } from './routes/experiences'
import { Route as First500RouteImport } from './routes/first-500'
import { Route as First500MembersRouteImport } from './routes/first-500-members'
import { Route as GroupDinnerExperienceRouteImport } from './routes/group-dinner-experience'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as InfluencerDinnersRouteImport } from './routes/influencer-dinners'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as JoinRouteImport } from './routes/join'
import { Route as LaunchRouteImport } from './routes/launch'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as MarketingUnsubscribeRouteImport } from './routes/marketing-unsubscribe'
import { Route as MeetSinglesInPersonRouteImport } from './routes/meet-singles-in-person'
import { Route as MembershipRouteImport } from './routes/membership'
import { Route as MessagesRouteImport } from './routes/messages'
import { Route as OaklandDinnersRouteImport } from './routes/oakland-dinners'
import { Route as OaklandSinglesDinnersRouteImport } from './routes/oakland-singles-dinners'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as ParentsDinnersRouteImport } from './routes/parents-dinners'
import { Route as PartnerApplyRouteImport } from './routes/partner-apply'
import { Route as PrivateDinnersRouteImport } from './routes/private-dinners'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as QuizRouteImport } from './routes/quiz'
import { Route as ReservationsRouteImport } from './routes/reservations'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RestaurantPartnersRouteImport } from './routes/restaurant-partners'
import { Route as SacramentoDinnersRouteImport } from './routes/sacramento-dinners'
import { Route as SacramentoSinglesDinnersRouteImport } from './routes/sacramento-singles-dinners'
import { Route as SanFranciscoDinnersRouteImport } from './routes/san-francisco-dinners'
import { Route as SanFranciscoSinglesDinnersRouteImport } from './routes/san-francisco-singles-dinners'
import { Route as SanJoseDinnersRouteImport } from './routes/san-jose-dinners'
import { Route as SanJoseSinglesDinnersRouteImport } from './routes/san-jose-singles-dinners'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SinglesDinnerEventsRouteImport } from './routes/singles-dinner-events'
import { Route as SinglesDinnerExperiencesRouteImport } from './routes/singles-dinner-experiences'
import { Route as SmsOptInRouteImport } from './routes/sms-opt-in'
import { Route as SocialDiningRouteImport } from './routes/social-dining'
import { Route as SocialDinnerClubsRouteImport } from './routes/social-dinner-clubs'
import { Route as TryRouteImport } from './routes/try'
import { Route as VenueApplicationRouteImport } from './routes/venue-application'
import { Route as VenuePortalRouteImport } from './routes/venue-portal'
import { Route as VerificationCompleteRouteImport } from './routes/verification-complete'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as VerifyProfileRouteImport } from './routes/verify-profile'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as PublicAboutRouteImport } from './routes/_public/about'
import { Route as PublicBecomeAffiliateRouteImport } from './routes/_public/become-affiliate'
import { Route as PublicBecomeCuratorRouteImport } from './routes/_public/become-curator'
import { Route as PublicCancellationPolicyRouteImport } from './routes/_public/cancellation-policy'
import { Route as PublicCareersRouteImport } from './routes/_public/careers'
import { Route as PublicCommunityGuidelinesRouteImport } from './routes/_public/community-guidelines'
import { Route as PublicContactRouteImport } from './routes/_public/contact'
import { Route as PublicFaqRouteImport } from './routes/_public/faq'
import { Route as PublicInsightsRouteImport } from './routes/_public/insights'
import { Route as PublicJournalRouteImport } from './routes/_public/journal'
import { Route as PublicLearnMoreRouteImport } from './routes/_public/learn-more'
import { Route as PublicLocationsRouteImport } from './routes/_public/locations'
import { Route as PublicOffersRouteImport } from './routes/_public/offers'
import { Route as PublicPartnerRouteImport } from './routes/_public/partner'
import { Route as PublicPartnerWithUsRouteImport } from './routes/_public/partner-with-us'
import { Route as PublicPartnersRouteImport } from './routes/_public/partners'
import { Route as PublicPricingRouteImport } from './routes/_public/pricing'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as PublicPrivacyPolicyRouteImport } from './routes/_public/privacy-policy'
import { Route as PublicSafetyRouteImport } from './routes/_public/safety'
import { Route as PublicTermsRouteImport } from './routes/_public/terms'
import { Route as PublicTermsOfServiceRouteImport } from './routes/_public/terms-of-service'
import { Route as PublicTrustVerificationRouteImport } from './routes/_public/trust-verification'
import { Route as PublicUnsubscribeRouteImport } from './routes/_public/unsubscribe'
import { Route as PublicWhatsNewRouteImport } from './routes/_public/whats-new'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAccountSettingsRouteImport } from './routes/admin/account-settings'
import { Route as AdminAddonsRouteImport } from './routes/admin/addons'
import { Route as AdminAffiliatesRouteImport } from './routes/admin/affiliates'
import { Route as AdminAiDailyAuditRouteImport } from './routes/admin/ai-daily-audit'
import { Route as AdminAiEcosystemRouteImport } from './routes/admin/ai-ecosystem'
import { Route as AdminAiEmailRouteImport } from './routes/admin/ai-email'
import { Route as AdminAiMatchingRouteImport } from './routes/admin/ai-matching'
import { Route as AdminAiMonitoringRouteImport } from './routes/admin/ai-monitoring'
import { Route as AdminAiSupportRouteImport } from './routes/admin/ai-support'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as AdminApplicationsRouteImport } from './routes/admin/applications'
import { Route as AdminApprovalsRouteImport } from './routes/admin/approvals'
import { Route as AdminAuditLogsRouteImport } from './routes/admin/audit-logs'
import { Route as AdminAutomationsRouteImport } from './routes/admin/automations'
import { Route as AdminBookingsRouteImport } from './routes/admin/bookings'
import { Route as AdminCampaignsRouteImport } from './routes/admin/campaigns'
import { Route as AdminCareersRouteImport } from './routes/admin/careers'
import { Route as AdminCirclesRouteImport } from './routes/admin/circles'
import { Route as AdminCitiesRouteImport } from './routes/admin/cities'
import { Route as AdminCityIntelligenceRouteImport } from './routes/admin/city-intelligence'
import { Route as AdminCityReadinessRouteImport } from './routes/admin/city-readiness'
import { Route as AdminCityRequestsRouteImport } from './routes/admin/city-requests'
import { Route as AdminCommsControlRouteImport } from './routes/admin/comms-control'
import { Route as AdminCommsMonitorRouteImport } from './routes/admin/comms-monitor'
import { Route as AdminCommunityRouteImport } from './routes/admin/community'
import { Route as AdminComplaintsRouteImport } from './routes/admin/complaints'
import { Route as AdminConciergeHighlightsRouteImport } from './routes/admin/concierge-highlights'
import { Route as AdminConciergeQueueRouteImport } from './routes/admin/concierge-queue'
import { Route as AdminConnectionsRouteImport } from './routes/admin/connections'
import { Route as AdminContentEngineRouteImport } from './routes/admin/content-engine'
import { Route as AdminContentIntelligenceRouteImport } from './routes/admin/content-intelligence'
import { Route as AdminCuratedInsightsRouteImport } from './routes/admin/curated-insights'
import { Route as AdminCuratorsRouteImport } from './routes/admin/curators'
import { Route as AdminDemoControlRouteImport } from './routes/admin/demo-control'
import { Route as AdminDinnersRouteImport } from './routes/admin/dinners'
import { Route as AdminEarlyAccessLeadsRouteImport } from './routes/admin/early-access-leads'
import { Route as AdminEcosystemHubRouteImport } from './routes/admin/ecosystem-hub'
import { Route as AdminEditorialRefineRouteImport } from './routes/admin/editorial-refine'
import { Route as AdminEmailCampaignCenterRouteImport } from './routes/admin/email-campaign-center'
import { Route as AdminEmailLogsRouteImport } from './routes/admin/email-logs'
import { Route as AdminEmailQueueHealthRouteImport } from './routes/admin/email-queue-health'
import { Route as AdminEventBuilderRouteImport } from './routes/admin/event-builder'
import { Route as AdminEventCheckinRouteImport } from './routes/admin/event-checkin'
import { Route as AdminFinanceRouteImport } from './routes/admin/finance'
import { Route as AdminFounderApprovalsRouteImport } from './routes/admin/founder-approvals'
import { Route as AdminFounding500RouteImport } from './routes/admin/founding-500'
import { Route as AdminInboxesRouteImport } from './routes/admin/inboxes'
import { Route as AdminJournalRouteImport } from './routes/admin/journal'
import { Route as AdminJourneyRouteImport } from './routes/admin/journey'
import { Route as AdminLaunchControlRouteImport } from './routes/admin/launch-control'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminMessagingCenterRouteImport } from './routes/admin/messaging-center'
import { Route as AdminNewsletterRouteImport } from './routes/admin/newsletter'
import { Route as AdminNotificationsRouteImport } from './routes/admin/notifications'
import { Route as AdminObservabilityRouteImport } from './routes/admin/observability'
import { Route as AdminPartnerVenuesRouteImport } from './routes/admin/partner-venues'
import { Route as AdminPartnershipsRouteImport } from './routes/admin/partnerships'
import { Route as AdminPaymentsRouteImport } from './routes/admin/payments'
import { Route as AdminPhase1ChecklistRouteImport } from './routes/admin/phase1-checklist'
import { Route as AdminPlansRouteImport } from './routes/admin/plans'
import { Route as AdminPlatformMonitorRouteImport } from './routes/admin/platform-monitor'
import { Route as AdminPlatformUpdatesRouteImport } from './routes/admin/platform-updates'
import { Route as AdminPromosRouteImport } from './routes/admin/promos'
import { Route as AdminQaRouteImport } from './routes/admin/qa'
import { Route as AdminQuizLeadsRouteImport } from './routes/admin/quiz-leads'
import { Route as AdminReferralCodesRouteImport } from './routes/admin/referral-codes'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminReservationsRouteImport } from './routes/admin/reservations'
import { Route as AdminReviewsRouteImport } from './routes/admin/reviews'
import { Route as AdminRolloutCommsRouteImport } from './routes/admin/rollout-comms'
import { Route as AdminSecurityRouteImport } from './routes/admin/security'
import { Route as AdminSeoPagesRouteImport } from './routes/admin/seo-pages'
import { Route as AdminSignatureRouteImport } from './routes/admin/signature'
import { Route as AdminSmsLogsRouteImport } from './routes/admin/sms-logs'
import { Route as AdminSocialMediaRouteImport } from './routes/admin/social-media'
import { Route as AdminSoftLaunchWaitlistRouteImport } from './routes/admin/soft-launch-waitlist'
import { Route as AdminSuperAdminRouteImport } from './routes/admin/super-admin'
import { Route as AdminSupportRouteImport } from './routes/admin/support'
import { Route as AdminTeamRouteImport } from './routes/admin/team'
import { Route as AdminTrackingRouteImport } from './routes/admin/tracking'
import { Route as AdminTrustScoresRouteImport } from './routes/admin/trust-scores'
import { Route as AdminUserStoriesRouteImport } from './routes/admin/user-stories'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminVenueApplicationsRouteImport } from './routes/admin/venue-applications'
import { Route as AdminVenuesRouteImport } from './routes/admin/venues'
import { Route as AdminVideoStudioRouteImport } from './routes/admin/video-studio'
import { Route as AdminWaitlistsRouteImport } from './routes/admin/waitlists'
import { Route as AdminWorkflowInspectorRouteImport } from './routes/admin/workflow-inspector'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AuthActionRouteImport } from './routes/auth/action'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as CheckinEventIdRouteImport } from './routes/checkin/$eventId'
import { Route as CitiesIndexRouteImport } from './routes/cities/index'
import { Route as CitiesCitySlugRouteImport } from './routes/cities/$citySlug'
import { Route as ConciergePackagesRouteImport } from './routes/concierge/packages'
import { Route as ExperiencesIndexRouteImport } from './routes/experiences/index'
import { Route as ExperiencesEventIdRouteImport } from './routes/experiences/$eventId'
import { Route as First500IndexRouteImport } from './routes/first-500/index'
import { Route as First500CancelRouteImport } from './routes/first-500/cancel'
import { Route as First500SuccessRouteImport } from './routes/first-500/success'
import { Route as Founding500SlugRouteImport } from './routes/founding-500/$slug'
import { Route as JoinIndexRouteImport } from './routes/join/index'
import { Route as JoinVerifyRouteImport } from './routes/join/verify'
import { Route as PartnerActivateRouteImport } from './routes/partner/activate'
import { Route as PartnerLoginRouteImport } from './routes/partner/login'
import { Route as PaymentConfirmRouteImport } from './routes/payment/confirm'
import { Route as PublicJournalIndexRouteImport } from './routes/_public/journal/index'
import { Route as PublicJournalSlugRouteImport } from './routes/_public/journal/$slug'
import { Route as PublicPoliciesCancellationRouteImport } from './routes/_public/policies/cancellation'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin/users/$userId'
import { Route as ApiTiktokCallbackRouteImport } from './routes/api/tiktok/callback'
import { Route as HostEventEventIdRouteImport } from './routes/host/event/$eventId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AdminInviteRoute = AdminInviteRouteImport.update({
            id: '/admin-invite',path: '/admin-invite',getParentRoute: () => rootRouteImport
          })
const AffiliatePortalRoute = AffiliatePortalRouteImport.update({
            id: '/affiliate-portal',path: '/affiliate-portal',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BillingRoute = BillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => rootRouteImport
          })
const BusinessNetworkingDinnersRoute = BusinessNetworkingDinnersRouteImport.update({
            id: '/business-networking-dinners',path: '/business-networking-dinners',getParentRoute: () => rootRouteImport
          })
const ChoosePlanRoute = ChoosePlanRouteImport.update({
            id: '/choose-plan',path: '/choose-plan',getParentRoute: () => rootRouteImport
          })
const CirclesRoute = CirclesRouteImport.update({
            id: '/circles',path: '/circles',getParentRoute: () => rootRouteImport
          })
const CitiesRoute = CitiesRouteImport.update({
            id: '/cities',path: '/cities',getParentRoute: () => rootRouteImport
          })
const ConciergeSubmittedRoute = ConciergeSubmittedRouteImport.update({
            id: '/concierge-submitted',path: '/concierge-submitted',getParentRoute: () => rootRouteImport
          })
const ConnectionsRoute = ConnectionsRouteImport.update({
            id: '/connections',path: '/connections',getParentRoute: () => rootRouteImport
          })
const CouplesDinnerExperiencesRoute = CouplesDinnerExperiencesRouteImport.update({
            id: '/couples-dinner-experiences',path: '/couples-dinner-experiences',getParentRoute: () => rootRouteImport
          })
const CuratedDiningExperiencesRoute = CuratedDiningExperiencesRouteImport.update({
            id: '/curated-dining-experiences',path: '/curated-dining-experiences',getParentRoute: () => rootRouteImport
          })
const CuratedMatchmakingDinnersRoute = CuratedMatchmakingDinnersRouteImport.update({
            id: '/curated-matchmaking-dinners',path: '/curated-matchmaking-dinners',getParentRoute: () => rootRouteImport
          })
const CuratorPortalRoute = CuratorPortalRouteImport.update({
            id: '/curator-portal',path: '/curator-portal',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const DatingAppAlternativeRoute = DatingAppAlternativeRouteImport.update({
            id: '/dating-app-alternative',path: '/dating-app-alternative',getParentRoute: () => rootRouteImport
          })
const DatingThroughDinnerRoute = DatingThroughDinnerRouteImport.update({
            id: '/dating-through-dinner',path: '/dating-through-dinner',getParentRoute: () => rootRouteImport
          })
const DinnerClubRoute = DinnerClubRouteImport.update({
            id: '/dinner-club',path: '/dinner-club',getParentRoute: () => rootRouteImport
          })
const DinnerWithStrangersRoute = DinnerWithStrangersRouteImport.update({
            id: '/dinner-with-strangers',path: '/dinner-with-strangers',getParentRoute: () => rootRouteImport
          })
const DiscoverRoute = DiscoverRouteImport.update({
            id: '/discover',path: '/discover',getParentRoute: () => rootRouteImport
          })
const EmailStatusRoute = EmailStatusRouteImport.update({
            id: '/email-status',path: '/email-status',getParentRoute: () => rootRouteImport
          })
const EmailUnsubscribeRoute = EmailUnsubscribeRouteImport.update({
            id: '/email-unsubscribe',path: '/email-unsubscribe',getParentRoute: () => rootRouteImport
          })
const EntrepreneurDinnersRoute = EntrepreneurDinnersRouteImport.update({
            id: '/entrepreneur-dinners',path: '/entrepreneur-dinners',getParentRoute: () => rootRouteImport
          })
const EventsRoute = EventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => rootRouteImport
          })
const ExperiencesRoute = ExperiencesRouteImport.update({
            id: '/experiences',path: '/experiences',getParentRoute: () => rootRouteImport
          })
const First500Route = First500RouteImport.update({
            id: '/first-500',path: '/first-500',getParentRoute: () => rootRouteImport
          })
const First500MembersRoute = First500MembersRouteImport.update({
            id: '/first-500-members',path: '/first-500-members',getParentRoute: () => rootRouteImport
          })
const GroupDinnerExperienceRoute = GroupDinnerExperienceRouteImport.update({
            id: '/group-dinner-experience',path: '/group-dinner-experience',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const InfluencerDinnersRoute = InfluencerDinnersRouteImport.update({
            id: '/influencer-dinners',path: '/influencer-dinners',getParentRoute: () => rootRouteImport
          })
const InviteRoute = InviteRouteImport.update({
            id: '/invite',path: '/invite',getParentRoute: () => rootRouteImport
          })
const JoinRoute = JoinRouteImport.update({
            id: '/join',path: '/join',getParentRoute: () => rootRouteImport
          })
const LaunchRoute = LaunchRouteImport.update({
            id: '/launch',path: '/launch',getParentRoute: () => rootRouteImport
          })
const LeaderboardRoute = LeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => rootRouteImport
          })
const MarketingUnsubscribeRoute = MarketingUnsubscribeRouteImport.update({
            id: '/marketing-unsubscribe',path: '/marketing-unsubscribe',getParentRoute: () => rootRouteImport
          })
const MeetSinglesInPersonRoute = MeetSinglesInPersonRouteImport.update({
            id: '/meet-singles-in-person',path: '/meet-singles-in-person',getParentRoute: () => rootRouteImport
          })
const MembershipRoute = MembershipRouteImport.update({
            id: '/membership',path: '/membership',getParentRoute: () => rootRouteImport
          })
const MessagesRoute = MessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => rootRouteImport
          })
const OaklandDinnersRoute = OaklandDinnersRouteImport.update({
            id: '/oakland-dinners',path: '/oakland-dinners',getParentRoute: () => rootRouteImport
          })
const OaklandSinglesDinnersRoute = OaklandSinglesDinnersRouteImport.update({
            id: '/oakland-singles-dinners',path: '/oakland-singles-dinners',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const ParentsDinnersRoute = ParentsDinnersRouteImport.update({
            id: '/parents-dinners',path: '/parents-dinners',getParentRoute: () => rootRouteImport
          })
const PartnerApplyRoute = PartnerApplyRouteImport.update({
            id: '/partner-apply',path: '/partner-apply',getParentRoute: () => rootRouteImport
          })
const PrivateDinnersRoute = PrivateDinnersRouteImport.update({
            id: '/private-dinners',path: '/private-dinners',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const QuizRoute = QuizRouteImport.update({
            id: '/quiz',path: '/quiz',getParentRoute: () => rootRouteImport
          })
const ReservationsRoute = ReservationsRouteImport.update({
            id: '/reservations',path: '/reservations',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RestaurantPartnersRoute = RestaurantPartnersRouteImport.update({
            id: '/restaurant-partners',path: '/restaurant-partners',getParentRoute: () => rootRouteImport
          })
const SacramentoDinnersRoute = SacramentoDinnersRouteImport.update({
            id: '/sacramento-dinners',path: '/sacramento-dinners',getParentRoute: () => rootRouteImport
          })
const SacramentoSinglesDinnersRoute = SacramentoSinglesDinnersRouteImport.update({
            id: '/sacramento-singles-dinners',path: '/sacramento-singles-dinners',getParentRoute: () => rootRouteImport
          })
const SanFranciscoDinnersRoute = SanFranciscoDinnersRouteImport.update({
            id: '/san-francisco-dinners',path: '/san-francisco-dinners',getParentRoute: () => rootRouteImport
          })
const SanFranciscoSinglesDinnersRoute = SanFranciscoSinglesDinnersRouteImport.update({
            id: '/san-francisco-singles-dinners',path: '/san-francisco-singles-dinners',getParentRoute: () => rootRouteImport
          })
const SanJoseDinnersRoute = SanJoseDinnersRouteImport.update({
            id: '/san-jose-dinners',path: '/san-jose-dinners',getParentRoute: () => rootRouteImport
          })
const SanJoseSinglesDinnersRoute = SanJoseSinglesDinnersRouteImport.update({
            id: '/san-jose-singles-dinners',path: '/san-jose-singles-dinners',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SigninRoute = SigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SinglesDinnerEventsRoute = SinglesDinnerEventsRouteImport.update({
            id: '/singles-dinner-events',path: '/singles-dinner-events',getParentRoute: () => rootRouteImport
          })
const SinglesDinnerExperiencesRoute = SinglesDinnerExperiencesRouteImport.update({
            id: '/singles-dinner-experiences',path: '/singles-dinner-experiences',getParentRoute: () => rootRouteImport
          })
const SmsOptInRoute = SmsOptInRouteImport.update({
            id: '/sms-opt-in',path: '/sms-opt-in',getParentRoute: () => rootRouteImport
          })
const SocialDiningRoute = SocialDiningRouteImport.update({
            id: '/social-dining',path: '/social-dining',getParentRoute: () => rootRouteImport
          })
const SocialDinnerClubsRoute = SocialDinnerClubsRouteImport.update({
            id: '/social-dinner-clubs',path: '/social-dinner-clubs',getParentRoute: () => rootRouteImport
          })
const TryRoute = TryRouteImport.update({
            id: '/try',path: '/try',getParentRoute: () => rootRouteImport
          })
const VenueApplicationRoute = VenueApplicationRouteImport.update({
            id: '/venue-application',path: '/venue-application',getParentRoute: () => rootRouteImport
          })
const VenuePortalRoute = VenuePortalRouteImport.update({
            id: '/venue-portal',path: '/venue-portal',getParentRoute: () => rootRouteImport
          })
const VerificationCompleteRoute = VerificationCompleteRouteImport.update({
            id: '/verification-complete',path: '/verification-complete',getParentRoute: () => rootRouteImport
          })
const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const VerifyProfileRoute = VerifyProfileRouteImport.update({
            id: '/verify-profile',path: '/verify-profile',getParentRoute: () => rootRouteImport
          })
const WaitlistRoute = WaitlistRouteImport.update({
            id: '/waitlist',path: '/waitlist',getParentRoute: () => rootRouteImport
          })
const PublicAboutRoute = PublicAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => PublicRoute
          })
const PublicBecomeAffiliateRoute = PublicBecomeAffiliateRouteImport.update({
            id: '/become-affiliate',path: '/become-affiliate',getParentRoute: () => PublicRoute
          })
const PublicBecomeCuratorRoute = PublicBecomeCuratorRouteImport.update({
            id: '/become-curator',path: '/become-curator',getParentRoute: () => PublicRoute
          })
const PublicCancellationPolicyRoute = PublicCancellationPolicyRouteImport.update({
            id: '/cancellation-policy',path: '/cancellation-policy',getParentRoute: () => PublicRoute
          })
const PublicCareersRoute = PublicCareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => PublicRoute
          })
const PublicCommunityGuidelinesRoute = PublicCommunityGuidelinesRouteImport.update({
            id: '/community-guidelines',path: '/community-guidelines',getParentRoute: () => PublicRoute
          })
const PublicContactRoute = PublicContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => PublicRoute
          })
const PublicFaqRoute = PublicFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => PublicRoute
          })
const PublicInsightsRoute = PublicInsightsRouteImport.update({
            id: '/insights',path: '/insights',getParentRoute: () => PublicRoute
          })
const PublicJournalRoute = PublicJournalRouteImport.update({
            id: '/journal',path: '/journal',getParentRoute: () => PublicRoute
          })
const PublicLearnMoreRoute = PublicLearnMoreRouteImport.update({
            id: '/learn-more',path: '/learn-more',getParentRoute: () => PublicRoute
          })
const PublicLocationsRoute = PublicLocationsRouteImport.update({
            id: '/locations',path: '/locations',getParentRoute: () => PublicRoute
          })
const PublicOffersRoute = PublicOffersRouteImport.update({
            id: '/offers',path: '/offers',getParentRoute: () => PublicRoute
          })
const PublicPartnerRoute = PublicPartnerRouteImport.update({
            id: '/partner',path: '/partner',getParentRoute: () => PublicRoute
          })
const PublicPartnerWithUsRoute = PublicPartnerWithUsRouteImport.update({
            id: '/partner-with-us',path: '/partner-with-us',getParentRoute: () => PublicRoute
          })
const PublicPartnersRoute = PublicPartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => PublicRoute
          })
const PublicPricingRoute = PublicPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => PublicRoute
          })
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => PublicRoute
          })
const PublicPrivacyPolicyRoute = PublicPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => PublicRoute
          })
const PublicSafetyRoute = PublicSafetyRouteImport.update({
            id: '/safety',path: '/safety',getParentRoute: () => PublicRoute
          })
const PublicTermsRoute = PublicTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => PublicRoute
          })
const PublicTermsOfServiceRoute = PublicTermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => PublicRoute
          })
const PublicTrustVerificationRoute = PublicTrustVerificationRouteImport.update({
            id: '/trust-verification',path: '/trust-verification',getParentRoute: () => PublicRoute
          })
const PublicUnsubscribeRoute = PublicUnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => PublicRoute
          })
const PublicWhatsNewRoute = PublicWhatsNewRouteImport.update({
            id: '/whats-new',path: '/whats-new',getParentRoute: () => PublicRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAccountSettingsRoute = AdminAccountSettingsRouteImport.update({
            id: '/account-settings',path: '/account-settings',getParentRoute: () => AdminRoute
          })
const AdminAddonsRoute = AdminAddonsRouteImport.update({
            id: '/addons',path: '/addons',getParentRoute: () => AdminRoute
          })
const AdminAffiliatesRoute = AdminAffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => AdminRoute
          })
const AdminAiDailyAuditRoute = AdminAiDailyAuditRouteImport.update({
            id: '/ai-daily-audit',path: '/ai-daily-audit',getParentRoute: () => AdminRoute
          })
const AdminAiEcosystemRoute = AdminAiEcosystemRouteImport.update({
            id: '/ai-ecosystem',path: '/ai-ecosystem',getParentRoute: () => AdminRoute
          })
const AdminAiEmailRoute = AdminAiEmailRouteImport.update({
            id: '/ai-email',path: '/ai-email',getParentRoute: () => AdminRoute
          })
const AdminAiMatchingRoute = AdminAiMatchingRouteImport.update({
            id: '/ai-matching',path: '/ai-matching',getParentRoute: () => AdminRoute
          })
const AdminAiMonitoringRoute = AdminAiMonitoringRouteImport.update({
            id: '/ai-monitoring',path: '/ai-monitoring',getParentRoute: () => AdminRoute
          })
const AdminAiSupportRoute = AdminAiSupportRouteImport.update({
            id: '/ai-support',path: '/ai-support',getParentRoute: () => AdminRoute
          })
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AdminRoute
          })
const AdminApplicationsRoute = AdminApplicationsRouteImport.update({
            id: '/applications',path: '/applications',getParentRoute: () => AdminRoute
          })
const AdminApprovalsRoute = AdminApprovalsRouteImport.update({
            id: '/approvals',path: '/approvals',getParentRoute: () => AdminRoute
          })
const AdminAuditLogsRoute = AdminAuditLogsRouteImport.update({
            id: '/audit-logs',path: '/audit-logs',getParentRoute: () => AdminRoute
          })
const AdminAutomationsRoute = AdminAutomationsRouteImport.update({
            id: '/automations',path: '/automations',getParentRoute: () => AdminRoute
          })
const AdminBookingsRoute = AdminBookingsRouteImport.update({
            id: '/bookings',path: '/bookings',getParentRoute: () => AdminRoute
          })
const AdminCampaignsRoute = AdminCampaignsRouteImport.update({
            id: '/campaigns',path: '/campaigns',getParentRoute: () => AdminRoute
          })
const AdminCareersRoute = AdminCareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => AdminRoute
          })
const AdminCirclesRoute = AdminCirclesRouteImport.update({
            id: '/circles',path: '/circles',getParentRoute: () => AdminRoute
          })
const AdminCitiesRoute = AdminCitiesRouteImport.update({
            id: '/cities',path: '/cities',getParentRoute: () => AdminRoute
          })
const AdminCityIntelligenceRoute = AdminCityIntelligenceRouteImport.update({
            id: '/city-intelligence',path: '/city-intelligence',getParentRoute: () => AdminRoute
          })
const AdminCityReadinessRoute = AdminCityReadinessRouteImport.update({
            id: '/city-readiness',path: '/city-readiness',getParentRoute: () => AdminRoute
          })
const AdminCityRequestsRoute = AdminCityRequestsRouteImport.update({
            id: '/city-requests',path: '/city-requests',getParentRoute: () => AdminRoute
          })
const AdminCommsControlRoute = AdminCommsControlRouteImport.update({
            id: '/comms-control',path: '/comms-control',getParentRoute: () => AdminRoute
          })
const AdminCommsMonitorRoute = AdminCommsMonitorRouteImport.update({
            id: '/comms-monitor',path: '/comms-monitor',getParentRoute: () => AdminRoute
          })
const AdminCommunityRoute = AdminCommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => AdminRoute
          })
const AdminComplaintsRoute = AdminComplaintsRouteImport.update({
            id: '/complaints',path: '/complaints',getParentRoute: () => AdminRoute
          })
const AdminConciergeHighlightsRoute = AdminConciergeHighlightsRouteImport.update({
            id: '/concierge-highlights',path: '/concierge-highlights',getParentRoute: () => AdminRoute
          })
const AdminConciergeQueueRoute = AdminConciergeQueueRouteImport.update({
            id: '/concierge-queue',path: '/concierge-queue',getParentRoute: () => AdminRoute
          })
const AdminConnectionsRoute = AdminConnectionsRouteImport.update({
            id: '/connections',path: '/connections',getParentRoute: () => AdminRoute
          })
const AdminContentEngineRoute = AdminContentEngineRouteImport.update({
            id: '/content-engine',path: '/content-engine',getParentRoute: () => AdminRoute
          })
const AdminContentIntelligenceRoute = AdminContentIntelligenceRouteImport.update({
            id: '/content-intelligence',path: '/content-intelligence',getParentRoute: () => AdminRoute
          })
const AdminCuratedInsightsRoute = AdminCuratedInsightsRouteImport.update({
            id: '/curated-insights',path: '/curated-insights',getParentRoute: () => AdminRoute
          })
const AdminCuratorsRoute = AdminCuratorsRouteImport.update({
            id: '/curators',path: '/curators',getParentRoute: () => AdminRoute
          })
const AdminDemoControlRoute = AdminDemoControlRouteImport.update({
            id: '/demo-control',path: '/demo-control',getParentRoute: () => AdminRoute
          })
const AdminDinnersRoute = AdminDinnersRouteImport.update({
            id: '/dinners',path: '/dinners',getParentRoute: () => AdminRoute
          })
const AdminEarlyAccessLeadsRoute = AdminEarlyAccessLeadsRouteImport.update({
            id: '/early-access-leads',path: '/early-access-leads',getParentRoute: () => AdminRoute
          })
const AdminEcosystemHubRoute = AdminEcosystemHubRouteImport.update({
            id: '/ecosystem-hub',path: '/ecosystem-hub',getParentRoute: () => AdminRoute
          })
const AdminEditorialRefineRoute = AdminEditorialRefineRouteImport.update({
            id: '/editorial-refine',path: '/editorial-refine',getParentRoute: () => AdminRoute
          })
const AdminEmailCampaignCenterRoute = AdminEmailCampaignCenterRouteImport.update({
            id: '/email-campaign-center',path: '/email-campaign-center',getParentRoute: () => AdminRoute
          })
const AdminEmailLogsRoute = AdminEmailLogsRouteImport.update({
            id: '/email-logs',path: '/email-logs',getParentRoute: () => AdminRoute
          })
const AdminEmailQueueHealthRoute = AdminEmailQueueHealthRouteImport.update({
            id: '/email-queue-health',path: '/email-queue-health',getParentRoute: () => AdminRoute
          })
const AdminEventBuilderRoute = AdminEventBuilderRouteImport.update({
            id: '/event-builder',path: '/event-builder',getParentRoute: () => AdminRoute
          })
const AdminEventCheckinRoute = AdminEventCheckinRouteImport.update({
            id: '/event-checkin',path: '/event-checkin',getParentRoute: () => AdminRoute
          })
const AdminFinanceRoute = AdminFinanceRouteImport.update({
            id: '/finance',path: '/finance',getParentRoute: () => AdminRoute
          })
const AdminFounderApprovalsRoute = AdminFounderApprovalsRouteImport.update({
            id: '/founder-approvals',path: '/founder-approvals',getParentRoute: () => AdminRoute
          })
const AdminFounding500Route = AdminFounding500RouteImport.update({
            id: '/founding-500',path: '/founding-500',getParentRoute: () => AdminRoute
          })
const AdminInboxesRoute = AdminInboxesRouteImport.update({
            id: '/inboxes',path: '/inboxes',getParentRoute: () => AdminRoute
          })
const AdminJournalRoute = AdminJournalRouteImport.update({
            id: '/journal',path: '/journal',getParentRoute: () => AdminRoute
          })
const AdminJourneyRoute = AdminJourneyRouteImport.update({
            id: '/journey',path: '/journey',getParentRoute: () => AdminRoute
          })
const AdminLaunchControlRoute = AdminLaunchControlRouteImport.update({
            id: '/launch-control',path: '/launch-control',getParentRoute: () => AdminRoute
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AdminRoute
          })
const AdminMessagingCenterRoute = AdminMessagingCenterRouteImport.update({
            id: '/messaging-center',path: '/messaging-center',getParentRoute: () => AdminRoute
          })
const AdminNewsletterRoute = AdminNewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => AdminRoute
          })
const AdminNotificationsRoute = AdminNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AdminRoute
          })
const AdminObservabilityRoute = AdminObservabilityRouteImport.update({
            id: '/observability',path: '/observability',getParentRoute: () => AdminRoute
          })
const AdminPartnerVenuesRoute = AdminPartnerVenuesRouteImport.update({
            id: '/partner-venues',path: '/partner-venues',getParentRoute: () => AdminRoute
          })
const AdminPartnershipsRoute = AdminPartnershipsRouteImport.update({
            id: '/partnerships',path: '/partnerships',getParentRoute: () => AdminRoute
          })
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AdminRoute
          })
const AdminPhase1ChecklistRoute = AdminPhase1ChecklistRouteImport.update({
            id: '/phase1-checklist',path: '/phase1-checklist',getParentRoute: () => AdminRoute
          })
const AdminPlansRoute = AdminPlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => AdminRoute
          })
const AdminPlatformMonitorRoute = AdminPlatformMonitorRouteImport.update({
            id: '/platform-monitor',path: '/platform-monitor',getParentRoute: () => AdminRoute
          })
const AdminPlatformUpdatesRoute = AdminPlatformUpdatesRouteImport.update({
            id: '/platform-updates',path: '/platform-updates',getParentRoute: () => AdminRoute
          })
const AdminPromosRoute = AdminPromosRouteImport.update({
            id: '/promos',path: '/promos',getParentRoute: () => AdminRoute
          })
const AdminQaRoute = AdminQaRouteImport.update({
            id: '/qa',path: '/qa',getParentRoute: () => AdminRoute
          })
const AdminQuizLeadsRoute = AdminQuizLeadsRouteImport.update({
            id: '/quiz-leads',path: '/quiz-leads',getParentRoute: () => AdminRoute
          })
const AdminReferralCodesRoute = AdminReferralCodesRouteImport.update({
            id: '/referral-codes',path: '/referral-codes',getParentRoute: () => AdminRoute
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AdminRoute
          })
const AdminReservationsRoute = AdminReservationsRouteImport.update({
            id: '/reservations',path: '/reservations',getParentRoute: () => AdminRoute
          })
const AdminReviewsRoute = AdminReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => AdminRoute
          })
const AdminRolloutCommsRoute = AdminRolloutCommsRouteImport.update({
            id: '/rollout-comms',path: '/rollout-comms',getParentRoute: () => AdminRoute
          })
const AdminSecurityRoute = AdminSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => AdminRoute
          })
const AdminSeoPagesRoute = AdminSeoPagesRouteImport.update({
            id: '/seo-pages',path: '/seo-pages',getParentRoute: () => AdminRoute
          })
const AdminSignatureRoute = AdminSignatureRouteImport.update({
            id: '/signature',path: '/signature',getParentRoute: () => AdminRoute
          })
const AdminSmsLogsRoute = AdminSmsLogsRouteImport.update({
            id: '/sms-logs',path: '/sms-logs',getParentRoute: () => AdminRoute
          })
const AdminSocialMediaRoute = AdminSocialMediaRouteImport.update({
            id: '/social-media',path: '/social-media',getParentRoute: () => AdminRoute
          })
const AdminSoftLaunchWaitlistRoute = AdminSoftLaunchWaitlistRouteImport.update({
            id: '/soft-launch-waitlist',path: '/soft-launch-waitlist',getParentRoute: () => AdminRoute
          })
const AdminSuperAdminRoute = AdminSuperAdminRouteImport.update({
            id: '/super-admin',path: '/super-admin',getParentRoute: () => AdminRoute
          })
const AdminSupportRoute = AdminSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AdminRoute
          })
const AdminTeamRoute = AdminTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AdminRoute
          })
const AdminTrackingRoute = AdminTrackingRouteImport.update({
            id: '/tracking',path: '/tracking',getParentRoute: () => AdminRoute
          })
const AdminTrustScoresRoute = AdminTrustScoresRouteImport.update({
            id: '/trust-scores',path: '/trust-scores',getParentRoute: () => AdminRoute
          })
const AdminUserStoriesRoute = AdminUserStoriesRouteImport.update({
            id: '/user-stories',path: '/user-stories',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const AdminVenueApplicationsRoute = AdminVenueApplicationsRouteImport.update({
            id: '/venue-applications',path: '/venue-applications',getParentRoute: () => AdminRoute
          })
const AdminVenuesRoute = AdminVenuesRouteImport.update({
            id: '/venues',path: '/venues',getParentRoute: () => AdminRoute
          })
const AdminVideoStudioRoute = AdminVideoStudioRouteImport.update({
            id: '/video-studio',path: '/video-studio',getParentRoute: () => AdminRoute
          })
const AdminWaitlistsRoute = AdminWaitlistsRouteImport.update({
            id: '/waitlists',path: '/waitlists',getParentRoute: () => AdminRoute
          })
const AdminWorkflowInspectorRoute = AdminWorkflowInspectorRouteImport.update({
            id: '/workflow-inspector',path: '/workflow-inspector',getParentRoute: () => AdminRoute
          })
const AuthIndexRoute = AuthIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthRoute
          })
const AuthActionRoute = AuthActionRouteImport.update({
            id: '/action',path: '/action',getParentRoute: () => AuthRoute
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/callback',path: '/callback',getParentRoute: () => AuthRoute
          })
const CheckinEventIdRoute = CheckinEventIdRouteImport.update({
            id: '/checkin/$eventId',path: '/checkin/$eventId',getParentRoute: () => rootRouteImport
          })
const CitiesIndexRoute = CitiesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CitiesRoute
          })
const CitiesCitySlugRoute = CitiesCitySlugRouteImport.update({
            id: '/$citySlug',path: '/$citySlug',getParentRoute: () => CitiesRoute
          })
const ConciergePackagesRoute = ConciergePackagesRouteImport.update({
            id: '/concierge/packages',path: '/concierge/packages',getParentRoute: () => rootRouteImport
          })
const ExperiencesIndexRoute = ExperiencesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ExperiencesRoute
          })
const ExperiencesEventIdRoute = ExperiencesEventIdRouteImport.update({
            id: '/$eventId',path: '/$eventId',getParentRoute: () => ExperiencesRoute
          })
const First500IndexRoute = First500IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => First500Route
          })
const First500CancelRoute = First500CancelRouteImport.update({
            id: '/cancel',path: '/cancel',getParentRoute: () => First500Route
          })
const First500SuccessRoute = First500SuccessRouteImport.update({
            id: '/success',path: '/success',getParentRoute: () => First500Route
          })
const Founding500SlugRoute = Founding500SlugRouteImport.update({
            id: '/founding-500/$slug',path: '/founding-500/$slug',getParentRoute: () => rootRouteImport
          })
const JoinIndexRoute = JoinIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => JoinRoute
          })
const JoinVerifyRoute = JoinVerifyRouteImport.update({
            id: '/verify',path: '/verify',getParentRoute: () => JoinRoute
          })
const PartnerActivateRoute = PartnerActivateRouteImport.update({
            id: '/partner/activate',path: '/partner/activate',getParentRoute: () => rootRouteImport
          })
const PartnerLoginRoute = PartnerLoginRouteImport.update({
            id: '/partner/login',path: '/partner/login',getParentRoute: () => rootRouteImport
          })
const PaymentConfirmRoute = PaymentConfirmRouteImport.update({
            id: '/payment/confirm',path: '/payment/confirm',getParentRoute: () => rootRouteImport
          })
const PublicJournalIndexRoute = PublicJournalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicJournalRoute
          })
const PublicJournalSlugRoute = PublicJournalSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => PublicJournalRoute
          })
const PublicPoliciesCancellationRoute = PublicPoliciesCancellationRouteImport.update({
            id: '/policies/cancellation',path: '/policies/cancellation',getParentRoute: () => PublicRoute
          })
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminUsersRoute
          })
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
            id: '/$userId',path: '/$userId',getParentRoute: () => AdminUsersRoute
          })
const ApiTiktokCallbackRoute = ApiTiktokCallbackRouteImport.update({
            id: '/api/tiktok/callback',path: '/api/tiktok/callback',getParentRoute: () => rootRouteImport
          })
const HostEventEventIdRoute = HostEventEventIdRouteImport.update({
            id: '/host/event/$eventId',path: '/host/event/$eventId',getParentRoute: () => rootRouteImport
          })





const PublicJournalRouteChildren = {
  PublicJournalSlugRoute: PublicJournalSlugRoute,PublicJournalIndexRoute: PublicJournalIndexRoute
}

const PublicJournalRouteWithChildren = PublicJournalRoute._addFileChildren(PublicJournalRouteChildren)



const PublicRouteChildren = {
  PublicAboutRoute: PublicAboutRoute,PublicBecomeAffiliateRoute: PublicBecomeAffiliateRoute,PublicBecomeCuratorRoute: PublicBecomeCuratorRoute,PublicCancellationPolicyRoute: PublicCancellationPolicyRoute,PublicCareersRoute: PublicCareersRoute,PublicCommunityGuidelinesRoute: PublicCommunityGuidelinesRoute,PublicContactRoute: PublicContactRoute,PublicFaqRoute: PublicFaqRoute,PublicInsightsRoute: PublicInsightsRoute,PublicJournalRoute: PublicJournalRouteWithChildren,PublicLearnMoreRoute: PublicLearnMoreRoute,PublicLocationsRoute: PublicLocationsRoute,PublicOffersRoute: PublicOffersRoute,PublicPartnerRoute: PublicPartnerRoute,PublicPartnerWithUsRoute: PublicPartnerWithUsRoute,PublicPartnersRoute: PublicPartnersRoute,PublicPricingRoute: PublicPricingRoute,PublicPrivacyRoute: PublicPrivacyRoute,PublicPrivacyPolicyRoute: PublicPrivacyPolicyRoute,PublicSafetyRoute: PublicSafetyRoute,PublicTermsRoute: PublicTermsRoute,PublicTermsOfServiceRoute: PublicTermsOfServiceRoute,PublicTrustVerificationRoute: PublicTrustVerificationRoute,PublicUnsubscribeRoute: PublicUnsubscribeRoute,PublicWhatsNewRoute: PublicWhatsNewRoute,PublicPoliciesCancellationRoute: PublicPoliciesCancellationRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)




const AdminUsersRouteChildren = {
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,AdminUsersIndexRoute: AdminUsersIndexRoute
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(AdminUsersRouteChildren)



const AdminRouteChildren = {
  AdminAccountSettingsRoute: AdminAccountSettingsRoute,AdminAddonsRoute: AdminAddonsRoute,AdminAffiliatesRoute: AdminAffiliatesRoute,AdminAiDailyAuditRoute: AdminAiDailyAuditRoute,AdminAiEcosystemRoute: AdminAiEcosystemRoute,AdminAiEmailRoute: AdminAiEmailRoute,AdminAiMatchingRoute: AdminAiMatchingRoute,AdminAiMonitoringRoute: AdminAiMonitoringRoute,AdminAiSupportRoute: AdminAiSupportRoute,AdminAnalyticsRoute: AdminAnalyticsRoute,AdminApplicationsRoute: AdminApplicationsRoute,AdminApprovalsRoute: AdminApprovalsRoute,AdminAuditLogsRoute: AdminAuditLogsRoute,AdminAutomationsRoute: AdminAutomationsRoute,AdminBookingsRoute: AdminBookingsRoute,AdminCampaignsRoute: AdminCampaignsRoute,AdminCareersRoute: AdminCareersRoute,AdminCirclesRoute: AdminCirclesRoute,AdminCitiesRoute: AdminCitiesRoute,AdminCityIntelligenceRoute: AdminCityIntelligenceRoute,AdminCityReadinessRoute: AdminCityReadinessRoute,AdminCityRequestsRoute: AdminCityRequestsRoute,AdminCommsControlRoute: AdminCommsControlRoute,AdminCommsMonitorRoute: AdminCommsMonitorRoute,AdminCommunityRoute: AdminCommunityRoute,AdminComplaintsRoute: AdminComplaintsRoute,AdminConciergeHighlightsRoute: AdminConciergeHighlightsRoute,AdminConciergeQueueRoute: AdminConciergeQueueRoute,AdminConnectionsRoute: AdminConnectionsRoute,AdminContentEngineRoute: AdminContentEngineRoute,AdminContentIntelligenceRoute: AdminContentIntelligenceRoute,AdminCuratedInsightsRoute: AdminCuratedInsightsRoute,AdminCuratorsRoute: AdminCuratorsRoute,AdminDemoControlRoute: AdminDemoControlRoute,AdminDinnersRoute: AdminDinnersRoute,AdminEarlyAccessLeadsRoute: AdminEarlyAccessLeadsRoute,AdminEcosystemHubRoute: AdminEcosystemHubRoute,AdminEditorialRefineRoute: AdminEditorialRefineRoute,AdminEmailCampaignCenterRoute: AdminEmailCampaignCenterRoute,AdminEmailLogsRoute: AdminEmailLogsRoute,AdminEmailQueueHealthRoute: AdminEmailQueueHealthRoute,AdminEventBuilderRoute: AdminEventBuilderRoute,AdminEventCheckinRoute: AdminEventCheckinRoute,AdminFinanceRoute: AdminFinanceRoute,AdminFounderApprovalsRoute: AdminFounderApprovalsRoute,AdminFounding500Route: AdminFounding500Route,AdminInboxesRoute: AdminInboxesRoute,AdminJournalRoute: AdminJournalRoute,AdminJourneyRoute: AdminJourneyRoute,AdminLaunchControlRoute: AdminLaunchControlRoute,AdminLoginRoute: AdminLoginRoute,AdminMessagingCenterRoute: AdminMessagingCenterRoute,AdminNewsletterRoute: AdminNewsletterRoute,AdminNotificationsRoute: AdminNotificationsRoute,AdminObservabilityRoute: AdminObservabilityRoute,AdminPartnerVenuesRoute: AdminPartnerVenuesRoute,AdminPartnershipsRoute: AdminPartnershipsRoute,AdminPaymentsRoute: AdminPaymentsRoute,AdminPhase1ChecklistRoute: AdminPhase1ChecklistRoute,AdminPlansRoute: AdminPlansRoute,AdminPlatformMonitorRoute: AdminPlatformMonitorRoute,AdminPlatformUpdatesRoute: AdminPlatformUpdatesRoute,AdminPromosRoute: AdminPromosRoute,AdminQaRoute: AdminQaRoute,AdminQuizLeadsRoute: AdminQuizLeadsRoute,AdminReferralCodesRoute: AdminReferralCodesRoute,AdminReportsRoute: AdminReportsRoute,AdminReservationsRoute: AdminReservationsRoute,AdminReviewsRoute: AdminReviewsRoute,AdminRolloutCommsRoute: AdminRolloutCommsRoute,AdminSecurityRoute: AdminSecurityRoute,AdminSeoPagesRoute: AdminSeoPagesRoute,AdminSignatureRoute: AdminSignatureRoute,AdminSmsLogsRoute: AdminSmsLogsRoute,AdminSocialMediaRoute: AdminSocialMediaRoute,AdminSoftLaunchWaitlistRoute: AdminSoftLaunchWaitlistRoute,AdminSuperAdminRoute: AdminSuperAdminRoute,AdminSupportRoute: AdminSupportRoute,AdminTeamRoute: AdminTeamRoute,AdminTrackingRoute: AdminTrackingRoute,AdminTrustScoresRoute: AdminTrustScoresRoute,AdminUserStoriesRoute: AdminUserStoriesRoute,AdminUsersRoute: AdminUsersRouteWithChildren,AdminVenueApplicationsRoute: AdminVenueApplicationsRoute,AdminVenuesRoute: AdminVenuesRoute,AdminVideoStudioRoute: AdminVideoStudioRoute,AdminWaitlistsRoute: AdminWaitlistsRoute,AdminWorkflowInspectorRoute: AdminWorkflowInspectorRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const AuthRouteChildren = {
  AuthActionRoute: AuthActionRoute,AuthCallbackRoute: AuthCallbackRoute,AuthIndexRoute: AuthIndexRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const CitiesRouteChildren = {
  CitiesCitySlugRoute: CitiesCitySlugRoute,CitiesIndexRoute: CitiesIndexRoute
}

const CitiesRouteWithChildren = CitiesRoute._addFileChildren(CitiesRouteChildren)




const ExperiencesRouteChildren = {
  ExperiencesEventIdRoute: ExperiencesEventIdRoute,ExperiencesIndexRoute: ExperiencesIndexRoute
}

const ExperiencesRouteWithChildren = ExperiencesRoute._addFileChildren(ExperiencesRouteChildren)




const First500RouteChildren = {
  First500CancelRoute: First500CancelRoute,First500SuccessRoute: First500SuccessRoute,First500IndexRoute: First500IndexRoute
}

const First500RouteWithChildren = First500Route._addFileChildren(First500RouteChildren)




const JoinRouteChildren = {
  JoinVerifyRoute: JoinVerifyRoute,JoinIndexRoute: JoinIndexRoute
}

const JoinRouteWithChildren = JoinRoute._addFileChildren(JoinRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,PublicRoute: PublicRouteWithChildren,AdminRoute: AdminRouteWithChildren,AdminInviteRoute: AdminInviteRoute,AffiliatePortalRoute: AffiliatePortalRoute,AppRoute: AppRoute,AuthRoute: AuthRouteWithChildren,BillingRoute: BillingRoute,BusinessNetworkingDinnersRoute: BusinessNetworkingDinnersRoute,ChoosePlanRoute: ChoosePlanRoute,CirclesRoute: CirclesRoute,CitiesRoute: CitiesRouteWithChildren,ConciergeSubmittedRoute: ConciergeSubmittedRoute,ConnectionsRoute: ConnectionsRoute,CouplesDinnerExperiencesRoute: CouplesDinnerExperiencesRoute,CuratedDiningExperiencesRoute: CuratedDiningExperiencesRoute,CuratedMatchmakingDinnersRoute: CuratedMatchmakingDinnersRoute,CuratorPortalRoute: CuratorPortalRoute,DashboardRoute: DashboardRoute,DatingAppAlternativeRoute: DatingAppAlternativeRoute,DatingThroughDinnerRoute: DatingThroughDinnerRoute,DinnerClubRoute: DinnerClubRoute,DinnerWithStrangersRoute: DinnerWithStrangersRoute,DiscoverRoute: DiscoverRoute,EmailStatusRoute: EmailStatusRoute,EmailUnsubscribeRoute: EmailUnsubscribeRoute,EntrepreneurDinnersRoute: EntrepreneurDinnersRoute,EventsRoute: EventsRoute,ExperiencesRoute: ExperiencesRouteWithChildren,First500Route: First500RouteWithChildren,First500MembersRoute: First500MembersRoute,GroupDinnerExperienceRoute: GroupDinnerExperienceRoute,HowItWorksRoute: HowItWorksRoute,InfluencerDinnersRoute: InfluencerDinnersRoute,InviteRoute: InviteRoute,JoinRoute: JoinRouteWithChildren,LaunchRoute: LaunchRoute,LeaderboardRoute: LeaderboardRoute,MarketingUnsubscribeRoute: MarketingUnsubscribeRoute,MeetSinglesInPersonRoute: MeetSinglesInPersonRoute,MembershipRoute: MembershipRoute,MessagesRoute: MessagesRoute,OaklandDinnersRoute: OaklandDinnersRoute,OaklandSinglesDinnersRoute: OaklandSinglesDinnersRoute,OnboardingRoute: OnboardingRoute,ParentsDinnersRoute: ParentsDinnersRoute,PartnerApplyRoute: PartnerApplyRoute,PrivateDinnersRoute: PrivateDinnersRoute,ProfileRoute: ProfileRoute,QuizRoute: QuizRoute,ReservationsRoute: ReservationsRoute,ResetPasswordRoute: ResetPasswordRoute,RestaurantPartnersRoute: RestaurantPartnersRoute,SacramentoDinnersRoute: SacramentoDinnersRoute,SacramentoSinglesDinnersRoute: SacramentoSinglesDinnersRoute,SanFranciscoDinnersRoute: SanFranciscoDinnersRoute,SanFranciscoSinglesDinnersRoute: SanFranciscoSinglesDinnersRoute,SanJoseDinnersRoute: SanJoseDinnersRoute,SanJoseSinglesDinnersRoute: SanJoseSinglesDinnersRoute,SettingsRoute: SettingsRoute,SigninRoute: SigninRoute,SignupRoute: SignupRoute,SinglesDinnerEventsRoute: SinglesDinnerEventsRoute,SinglesDinnerExperiencesRoute: SinglesDinnerExperiencesRoute,SmsOptInRoute: SmsOptInRoute,SocialDiningRoute: SocialDiningRoute,SocialDinnerClubsRoute: SocialDinnerClubsRoute,TryRoute: TryRoute,VenueApplicationRoute: VenueApplicationRoute,VenuePortalRoute: VenuePortalRoute,VerificationCompleteRoute: VerificationCompleteRoute,VerifyEmailRoute: VerifyEmailRoute,VerifyProfileRoute: VerifyProfileRoute,WaitlistRoute: WaitlistRoute,CheckinEventIdRoute: CheckinEventIdRoute,ConciergePackagesRoute: ConciergePackagesRoute,Founding500SlugRoute: Founding500SlugRoute,PartnerActivateRoute: PartnerActivateRoute,PartnerLoginRoute: PartnerLoginRoute,PaymentConfirmRoute: PaymentConfirmRoute,ApiTiktokCallbackRoute: ApiTiktokCallbackRoute,HostEventEventIdRoute: HostEventEventIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)